import Head from 'next/head'

export interface HotjarScriptProps {
  // comma separated string, format: hjid,hjsv
  hotjarConfig: string
}

export const HotjarScript: React.FC<HotjarScriptProps> = ({ hotjarConfig }) => {
  const [hjid, hjsv] = hotjarConfig.split(',')

  const scriptContent = `
(function(h,o,t,j,a,r){
h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
h._hjSettings={hjid:${hjid},hjsv:${hjsv}};
a=o.getElementsByTagName('head')[0];
r=o.createElement('script');r.async=1;
r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
a.appendChild(r);
})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `

  return (
    <Head>
      <script dangerouslySetInnerHTML={{ __html: scriptContent }} />
    </Head>
  )
}

export default HotjarScript
